<template>
    <div class="email-template-filter-toolbar">
        <CommonFilterTool
            v-model="emailTemplateFilter"
            :keep-state-on-query-params="false"
            :filter-meta="filterMetas"
            :label-formatter="filterLabelFormatter"
            @addFilter="addFilter"
            @clear-all="clearAllFilters"
        >
            <template slot="extra">
                <slot name="extra" />
            </template>
        </CommonFilterTool>
    </div>
</template>

<script>
import CommonFilterTool from "../../Chatbot/pages/archive/CommonFilterTool.vue";
import { mapState } from "vuex";

export default {
    name: "EmailTemplateFilterToolbar",
    components: { CommonFilterTool },
    data() {
        return {
            emailTemplateFilter: [],
            filterMetas: [
                {
                    name: "name",
                    label: this.$t("mail.templateName"),
                    materialIcon: "title",
                    controlType: "input",
                    availableOperators: ["equal", "contains"],
                    controlProps: {},
                    defaultValue: "",
                },
                {
                    name: "subject",
                    label: this.$t("message.subject"),
                    materialIcon: "subject",
                    controlType: "input",
                    availableOperators: ["equal", "contains"],
                    controlProps: {},
                    defaultValue: "",
                },
                {
                    name: "category",
                    label: this.$t("mail.category"),
                    materialIcon: "category",
                    controlType: "select",
                    options: () => [
                        { id: "marketing", label: this.$t("mail.marketing") },
                        { id: "operational", label: this.$t("mail.operational") },
                        { id: "private", label: "Özel" },
                    ],
                    defaultValue: "",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    methods: {
        addFilter(name, value, autoOpen = true) {
            const meta = this.filterMetas.find((x) => x.name === name);
            const filter = this.emailTemplateFilter.find((x) => x.name === name);
            if (filter) {
                this.emailTemplateFilter = this.emailTemplateFilter.map((x) => {
                    if (x.name === name) {
                        x.filterValue = value || meta.defaultValue;
                    }
                    return x;
                });
            } else {
                this.emailTemplateFilter.push({
                    name: meta.name,
                    label: meta.label,
                    filterValue: value || meta.defaultValue,
                    materialIcon: meta.materialIcon,
                    controlType: meta.controlType,
                    options: meta.options,
                });
            }

            if (autoOpen) {
                setTimeout(() => {
                    const el = document.querySelector(".filter-wrapper-preview[data-filter-name=" + name + "]");
                    if (el) {
                        el.click();
                    }
                }, 100);
            }
        },
        removeFilter(name) {
            this.emailTemplateFilter = this.emailTemplateFilter.filter((x) => x.name !== name);
        },
        clearAllFilters() {
            this.emailTemplateFilter = [];
        },
        filterLabelFormatter(name, value) {
            const filter = this.filterMetas.find((x) => x.name === name);
            if (filter.controlType === "select") {
                const option = filter.options().find((x) => x.id === value);
                return `${filter.label}: ${option?.label || value}`;
            } else {
                return `${filter.label}: ${value}`;
            }
        },
        isFilterExists(name) {
            return !!this.emailTemplateFilter.find((x) => x.name === name);
        },
    },
    watch: {
        emailTemplateFilter: {
            handler: function () {
                this.$emit("input", this.emailTemplateFilter);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.email-template-filter-toolbar {
    .common-filter-tool {
        padding: 0 !important;
        border: none !important;
    }
}
</style>
